import script from "./KycView.vue?vue&type=script&setup=true&lang=js"
export * from "./KycView.vue?vue&type=script&setup=true&lang=js"

import "./KycView.vue?vue&type=style&index=0&id=24c88878&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24c88878"]])

export default __exports__